import { styled } from '@linaria/react';

export const RowContent = styled.div`
  width: 100%;
  align-items: center;
  padding: 0;
  display: grid;
  grid-template-columns: auto 1fr min-content min-content;
  grid-template-areas:
    'bet-wrapper bet-wrapper score best-odds-buttons match-stats-button'
    'start-time see-all-odds see-all-odds see-all-odds see-all-odds';

  @media (min-width: 768px) {
    grid-template-columns: min-content min-content 1fr auto auto auto;
    grid-template-areas: 'start-time in-play-time-wrapper bet-wrapper score separator match-stats-button best-odds-buttons see-all-odds';
    align-items: center;
  }
`;

export const StartTime = styled.a`
  font-family: var(--oc-font-family);
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  text-align: left;
  min-width: 40px;
  padding: 0 0 0 5px;
  line-height: 18px;
  grid-area: start-time;
  color: var(--oc-text-subtext);
  cursor: pointer;
  text-decoration: inherit;

  @media (min-width: 768px) {
    color: var(--ogm-text-body);
    line-height: 19px;
    padding: 0 25px 0 0;
    font-weight: bold;
    text-align: center;
  }
`;

export const Separator = styled.div`
  grid-area: separator;
  width: 1px;
  height: 40px;
  display: none;

  @media (min-width: 768px) {
    display: block;
    border-left: 0;
    margin: 0 5px;
  }

  @media (min-width: 1024px) {
    border-left: 1px solid var(--oc-line-secondary);
    display: block;
  }
`;

// adding a placeoholder (if needed) to not mess up the grid-template
export const MatchStatsButtonPlaceHolder = styled.div`
  grid-area: match-stats-button;
`;
